module.exports = __webpack_public_path__ + "static/img/speciality-diff.b3ff4906.png";